<script setup lang="ts" generic="T extends ChoiceData">

import type { HandlungBausteinProps, ChoiceData } from '@/api/handlungen/types';
import { ElRadio, ElRadioGroup } from 'element-plus';

defineProps<HandlungBausteinProps<T>>();

const model = defineModel({ type: String, default: '' });
</script>

<template>
  <div class="p-3 my-2 rounded-md border border-gray-100">
    <ElRadioGroup
      v-model="model"
      class="el-radio-group--stacked space-y-5"
    >
      <ElRadio
        v-for="({ id, label }) in baustein.data.options"
        :key="id"
        :value="id"
      >
        {{ label }}
      </ElRadio>
    </ElRadioGroup>
  </div>
</template>
